import(/* webpackMode: "eager" */ "/app/src/app/(consent-manger)/[locale]/(popover-footer)/(custome-header-design)/inbox/page.tsx");
